// extracted by mini-css-extract-plugin
export default {"custom-scrollbar":"captivePortal_custom-scrollbar__o1xLj","collapse-typography":"captivePortal_collapse-typography__AXj7S"};